import axios, { ResponseType } from './axios';
import { OperationResponse } from '~/types/api/client';
// import { apiClient } from './client';
import { getAlreadyFilledData, Identity } from './onboarding';
import { Paths } from '~/types/api/generatedApiClient';

export const login = (email: string, password: string): ResponseType => {
  return axios.post('/auth/password/authenticate', { username: email, password });
};

export const changePassword = (
  body: Paths.PasswordManagement.RequestBody
): OperationResponse<void> => {
  return axios.put('/auth/password', body);
};

export const verifyToken = getAlreadyFilledData;

export const getLoggedIdentity = (): ResponseType<Identity> => {
  return axios.get<Identity>('/auth/identity');
};

export const authenticateWithInvitationToken = (token: string): ResponseType => {
  return axios.post('/auth/invitation/authenticate', { token });
};

export const requestPasswordReset = (email: string): ResponseType => {
  return axios.post('/auth/password/reset/request', {
    email,
  });
};

export const passwordResetCheck = (token: string): ResponseType => {
  return axios.post('/auth/password/reset/check', { token });
};

export const passwordReset = (body: { token: string; newPassword: string }): ResponseType => {
  return axios.post('/auth/password/reset', body);
};
